<template>
	<el-row class="maintwobox">
		<!-- 内容 -->
		<el-row class="mainOnebox_main">
			<div class="mainOnebox_main_list">
				<img src="@/assets/image/home/map.png">
				<el-row class="mainOnebox_main_list_main">
					<el-row class="mainOnebox_main_list_name1"> <span class="el-icon-location" ></span> ADD
					</el-row>
					<el-row class="mainOnebox_main_list_name2">
						<span>B2-308D , Jiangcun Business Center830 Wenyixi Rd , Hangzhou , ZhejiangChina 310030</span> <br><br>
						<br><br>
					</el-row>
				</el-row>
			</div>
			<div class="mainOnebox_main_list_bot_b"></div>
		</el-row>
		<div class="mainOnebox_main_list_bot"></div>
	</el-row>
</template>

<script>
	// import banner from './components/banner.vue';

	export default {
		components: {
			// banner:banner,
		},
		data() {
			return {

			}
		},
		methods: {

		},

	}
</script>

<style lang="less" scoped>
	@vw: 19.2vw;

	.maintwobox {
		width: 100%;
		height: auto;
		background: #fff;

		.mainOnebox_main {
			width: 100%;
			max-width: 1530px;
			margin: 0 auto;
			height: auto;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: row;
			flex-wrap: wrap;

			.mainOnebox_main_list {
				width: 100%;
				height: auto;
				margin: 0 1.5vw;
				border-radius: 5px;
				overflow: hidden;
				display: flex;
				align-items: center;
				justify-content: center;
				text-align: left;
				position: relative;
				z-index: 9;
				img {
					width: 616/@vw;
					height: 466/@vw;
					border-radius: 1vw;
					margin-left: 3vw;
				}
				.mainOnebox_main_list_main{
					padding-top: 3vh;
					.mainOnebox_main_list_name1 {
						max-width: 414px;
						font-weight: 700;
						color: #b28847;
						font-size: 32/@vw;
						padding-left: 30/@vw;
						box-sizing: border-box;
					}
					
					.mainOnebox_main_list_name2 {
						max-width: 414px;
						margin-top: 30/@vw;
						color: #1a1a1a;
						font-size: 24/@vw;
						padding-left: 30/@vw;
					}
				}


			}

			.mainOnebox_main_list_bot_b{
				width: 100%;
				height: 210/@vw;
			}

		}
		.mainOnebox_main_list_bot{
			width: 100%;
			height: 360/@vw;
			background-color: #f6f9f9;
			position: absolute;
			left: 0;
			bottom: 0;
			z-index: 1;
		}
	}
</style>
